/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Cancel_ButtonInputs */

const en_explorer_thumbnail_cancel_button = /** @type {(inputs: Explorer_Thumbnail_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_explorer_thumbnail_cancel_button = /** @type {(inputs: Explorer_Thumbnail_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_explorer_thumbnail_cancel_button = /** @type {(inputs: Explorer_Thumbnail_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornieren`)
};

const it_explorer_thumbnail_cancel_button = /** @type {(inputs: Explorer_Thumbnail_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellare`)
};

const ru_explorer_thumbnail_cancel_button = /** @type {(inputs: Explorer_Thumbnail_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_explorer_thumbnail_cancel_button = /** @type {(inputs: Explorer_Thumbnail_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const zh_cn2_explorer_thumbnail_cancel_button = /** @type {(inputs: Explorer_Thumbnail_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_explorer_thumbnail_cancel_button = /** @type {(inputs: Explorer_Thumbnail_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const hi_explorer_thumbnail_cancel_button = /** @type {(inputs: Explorer_Thumbnail_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करना`)
};

const pt_pt2_explorer_thumbnail_cancel_button = /** @type {(inputs: Explorer_Thumbnail_Cancel_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Explorer_Thumbnail_Cancel_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_cancel_button = /** @type {((inputs?: Explorer_Thumbnail_Cancel_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Cancel_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_cancel_button(inputs)
	if (locale === "de") return de_explorer_thumbnail_cancel_button(inputs)
	if (locale === "it") return it_explorer_thumbnail_cancel_button(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_cancel_button(inputs)
	if (locale === "es") return es_explorer_thumbnail_cancel_button(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_cancel_button(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_cancel_button(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_cancel_button(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_cancel_button(inputs)
	return en_explorer_thumbnail_cancel_button(inputs)
});